module.exports = __webpack_public_path__ + "static/media/agent.9b8181a7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/agent.svg
// module id = 205
// module chunks = 17